// Recipe visual: a real photo when available, otherwise a calm Quiet Board
// fallback — a muted meal-category line icon on a sunken square. No emoji,
// gradients, grids, or glows (per the design system: imagery is photography;
// where there's none, an icon stands in on a sunken square).
import { MealIcon } from './MealIcon';

/**
 * Small inline recipe thumbnail for lists, plan slots, and other inline spots.
 */
export function RecipeThumb({ recipe, className = 'w-10 h-10' }) {
  const name = recipe?.name || 'Recipe';

  if (recipe?.image_url) {
    return (
      <img
        src={recipe.image_url}
        alt={name}
        className={`${className} rounded-lg object-cover`}
        loading="lazy"
      />
    );
  }

  return (
    <div
      className={`${className} rounded-lg bg-surface-sunken text-ink-muted flex items-center justify-center`}
      role="img"
      aria-label={name}
    >
      <MealIcon meal={recipe?.category} className="w-5 h-5" />
    </div>
  );
}

// Full-width recipe photo. Text-forward now: render nothing when there's no
// photo (no empty placeholder box) — callers lay out fine without it.
export default function RecipeImage({ recipe, className = 'h-52' }) {
  const name = recipe?.name || 'Recipe';
  if (!recipe?.image_url) return null;

  return (
    <div className={`relative w-full ${className} bg-surface`}>
      <img src={recipe.image_url} alt={name} className="w-full h-full object-cover" loading="lazy" />
    </div>
  );
}
